import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { AnalyticsService } from '@shared/services/analytics.service';
import { LoadState } from '../loader-directive/loader.module';
import { Annotation, AnnotationType, typeData } from '@shared/models';
import { AnnotationData } from './annotation-stat-item/annotation-stat-item.component';

@Component({
  selector: 'annotations-stats',
  templateUrl: './annotations-stats.component.html',
  styleUrls: ['./annotations-stats.component.scss']
})

export class AnnotationsStatComponent implements OnInit, OnChanges {
  @Input() annotations: Annotation[];
  annotationIds: string[];
  @Input() date_from: Date;
  @Input() date_to: Date;
  @Input() sceneUsersCount: number;
  fetchedAnnotationStats: {
    _id: string,
    activity: string,
    annotation_id: string,
    userNum: number
  }[];
  loadStatus: string;

  constructor(
    private _analyticsService: AnalyticsService,
  ) {

  }

  ngOnInit(): void {
    this.updateStats();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if ((changes.date_from && !changes.date_from.isFirstChange() && changes.date_from.currentValue !== changes.date_from.previousValue)
    || (changes.date_to && !changes.date_to.isFirstChange() && changes.date_to.currentValue !== changes.date_to.previousValue)) {
      this.updateStats();
    }
  }
  async updateStats(): Promise<void> {
    this.loadStatus = LoadState.loading;
    this.annotationIds = this.annotations.map(annotation => annotation.id)
    this.fetchedAnnotationStats = await this._analyticsService.getAnnotationsStats(this.annotationIds, { dateFrom: this.date_from, dateTo: this.date_to }).toPromise()
    this.loadStatus = LoadState.completed;
  }
  getAnnotationThumbnail(annotation: Annotation): { thumbnail?: string, thumbnailSVG?: string, thumbnailIcon?: string } {
    switch (annotation.type) {
      case AnnotationType.text:
      case AnnotationType.card:
      case AnnotationType.quiz:
      case AnnotationType.scorecard:
      case AnnotationType.hotspot:
        return { thumbnailSVG: typeData.get(annotation.type).iconName };
      case AnnotationType.image:
      case AnnotationType.video:
      case AnnotationType.object3D:
        return { thumbnail: annotation.media?.thumbnail, thumbnailIcon: typeData.get(annotation.type).iconName };
      default:
        return { thumbnailSVG: '' };
    }
  }
  getAnnotationData(annotation: Annotation): AnnotationData {

    const annotationStats = this.fetchedAnnotationStats.find((a) => a.annotation_id === annotation.id);
    return {
      id: annotation.id,
      type: annotation.type,
      label: annotation.label,
      ...this.getAnnotationThumbnail(annotation),
      userPercentage: annotationStats && Math.min(Math.floor(annotationStats.userNum / this.sceneUsersCount * 100), 100)
    }
  }
}
